/* eslint-disable prefer-arrow-callback,no-var */
(function textbox(window) {
  var textboxes = window.document.querySelectorAll('.tc_textbox');

  Array.prototype.forEach.call(textboxes, function textboxLoop(textbox) {
    var textboxGrandParent = textbox.parentNode.parentNode;
    var textboxHeight = textbox.offsetHeight;
    var textboxBodyHeight = textbox.querySelector('.tc_textbox__body')
      .offsetHeight;
    var textboxButton;
    var buffer = 150;

    if (textboxBodyHeight > textboxHeight + buffer) {
      textboxButton = textbox.querySelector('.tc_linkmore');
      textboxButton.addEventListener('click', function footerClick() {
        if (textboxGrandParent.getAttribute('data-object-position')) {
          textboxGrandParent.setAttribute('data-object-position', 'default');
        }
        textbox.classList.toggle('js_textbox--open');
      });
      textbox.classList.add('js_textbox--toggle');
    } else {
      textbox.classList.add('js_textbox--notoggle');
    }
  });
})(window);
